/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import _ from "lodash"

// other
import { useEffect, useState } from "react"
import { Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch } from "react-redux"

import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"

import SyaryoCountService from "../../../service/truck/syaryoCount/syaryoCountService"
import { TSyaryoCountListGetRes } from "../../../service/truck/syaryoCount/TSyaryoCount"

type TGridData = {
  会社ID: number
  会社名: string
  営業所ID: number
  営業所名: string
  総合計_EG: number
  総合計_トレーラ: number
  [name: string]: number | string
}

/**
 * 部所マスタ一覧
 * @returns
 */
const SyaryoCountList = () => {
  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "SyaryoCountList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: TSyaryoCountListGetRes,
    pageSize: number
  ) => {
    //データを営業所ごとに横に並べる

    const gridData: TGridData[] = []
    data.forEach((d) => {
      const targetData = gridData.find(
        (gd) => gd.会社ID === d.会社ID && gd.営業所ID === d.営業所ID
      )
      if (targetData != null) {
        targetData[`${d.原動機有無フラグ}_${d.支払先ID ?? "未設定"}`] =
          d.車輌台数
        if (d.原動機有無フラグ === 1) {
          targetData.総合計_EG += d.車輌台数
        } else {
          targetData.総合計_トレーラ += d.車輌台数
        }
      } else {
        const newData: TGridData = {
          会社ID: d.会社ID,
          会社名: d.会社名,
          営業所ID: d.営業所ID,
          営業所名: d.営業所名,
          総合計_EG: d.原動機有無フラグ === 1 ? d.車輌台数 : 0,
          総合計_トレーラ: d.原動機有無フラグ === 0 ? d.車輌台数 : 0,
        }
        newData[`${d.原動機有無フラグ}_${d.支払先ID ?? "未設定"}`] = d.車輌台数
        gridData.push(newData)
      }
    })
    return new wjCore.CollectionView(gridData, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      groupDescriptions: [
        new wjCore.PropertyGroupDescription("総計", function (item, propName) {
          return ""
        }),
        "会社名",
      ],
      calculatedFields: {
        総合計_合計: (d: TGridData) => d.総合計_EG + d.総合計_トレーラ,
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    try {
      const res = await new SyaryoCountService().getList()

      // 検索結果をstateにセット

      createColumns(res.data)
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      console.log(error)
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  const createColumns = (data: TSyaryoCountListGetRes) => {
    if (flexGrid == null) return
    const columnProperties: {
      header: string
      binding: string
    }[] = []
    const rowList = _.orderBy(
      _.uniq(
        data.map((d) => ({
          原動機有無フラグ: d.原動機有無フラグ,
          支払先コード: d.支払先コード,
          支払先ID: d.支払先ID,
          支払先略称: d.支払先略称,
        }))
      ),
      ["原動機有無フラグ", "支払先コード"],
      ["desc", "asc"]
    )

    rowList.forEach((d) => {
      const binding = `${d.原動機有無フラグ}_${d.支払先ID ?? "未設定"}`
      if (!columnProperties.find((c) => c.binding === binding)) {
        columnProperties.push({
          binding,
          header: d.支払先略称 ?? "不明",
        })
      }
    })
    columnProperties.forEach((cp) => {
      if (flexGrid.getColumn(cp.binding)) return
      const c = new wjGrid.Column()
      c.binding = cp.binding
      c.header = cp.header
      c.allowMerging = true
      c.wordWrap = true
      c.width = 55
      c.align = "right"
      c.aggregate = wjCore.Aggregate.Sum
      flexGrid.columns.push(c)
    })

    //ヘッダー結合
    let panel = flexGrid.columnHeaders

    panel.columns.forEach((column) => {
      if (column.binding?.startsWith("1_")) {
        panel.setCellData(0, column.index, "E/G")
      }
      if (column.binding?.startsWith("0_")) {
        panel.setCellData(0, column.index, "トレーラ")
      }
      column.wordWrap = true
    })
    if (panel.rows && panel.rows[1] != null) {
      panel.rows[1].height = 60
    }

    flexGrid.refresh()
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)
    let extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    let panel = grid.columnHeaders
    panel.rows.splice(0, 0, extraRow)

    const 営業所binding: string[] = ["会社名", "営業所名"]
    営業所binding.forEach(function (binding) {
      let col = grid.getColumn(binding)
      col.allowMerging = true
      panel.setCellData(0, col.index, "営業所")
    })

    const 合計binding: string[] = [
      "総合計_合計",
      "総合計_EG",
      "総合計_トレーラ",
    ]
    合計binding.forEach(function (binding) {
      let col = grid.getColumn(binding)
      col.allowMerging = true
      panel.setCellData(0, col.index, "総合計")
    })

    grid.itemFormatter = (panel, r, c, cell) => {
      if (panel.cellType === wjGrid.CellType.ColumnHeader) {
        cell.style.textAlign = "left"
      }
    }

    grid.formatItem.addHandler((grid, e: wjGrid.FormatItemEventArgs) => {
      if (grid.cells === e.panel) {
        let data = grid.getCellData(e.row, e.col, false)
        if (data === "" || data == null) {
          e.cell.innerHTML = "0"
        }
      }
      const groupRow = e.getRow()
      if (groupRow instanceof wjGrid.GroupRow) {
        groupRow.cssClassAll = "fw-bold"
      }
    })
    grid.groupHeaderFormat = "{name}: {value}"

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [effect]

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    const abortController = new AbortController()
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      // リストア中フラグON
      setIsRestoreSearching(true)

      // 再検索
      search().finally(() => {
        dispatch(画面ロック解除())
      })
    }
    return () => {
      abortController.abort()
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `車両台数一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">車両台数一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                hasFilter={false}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                isEnablePageSize={"hidden"}
                style={{ maxHeight: "auto" }}
                gridProperties={{
                  frozenColumns: 2,
                  autoGenerateColumns: false,
                }}
                gridInitializedHandler={gridInitializedHandler}>
                <wjrGrid.FlexGridColumn
                  binding="会社名"
                  align={"left"}
                  allowDragging={false}
                  width={200}
                  header="会社"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="営業所名"
                  allowDragging={false}
                  align={"left"}
                  width={100}
                  header="営業所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="総合計_合計"
                  align={"right"}
                  aggregate="Sum"
                  width={60}
                  header="合計"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="総合計_EG"
                  align={"right"}
                  aggregate="Sum"
                  width={60}
                  header="E/G"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="総合計_トレーラ"
                  align={"right"}
                  aggregate="Sum"
                  width={60}
                  header="トレーラ"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default SyaryoCountList
